import React from 'react'
import { Button } from 'antd'
import './index.css'

const ButtonPurple = ({
  buttonText = 'Submit',
  loading = false,
  disabled = false,
  htmlType = 'submit',
  title = '',
  holderStyles = {},
  buttonStyles = {},
  onClick = () => {},
  disabledColored = false,
}) => {
  return (
    <div style={holderStyles} className="button-holder-purple">
      <Button
        type="primary"
        htmlType={htmlType}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        title={title}
        style={buttonStyles}
        className={disabledColored ? 'custom-disabled-colored-btn' : ''}
      >
        {buttonText}
      </Button>
      <div className="btn-highlight-hover" />
    </div>
  )
}

export default ButtonPurple
